import { supabase } from '../lib/supabase';

export const scheduleService = {
  // Create service schedule (public - no auth required)
  async create(scheduleData) {
    try {
      // Check if user is authenticated
      const { data: { user } } = await supabase?.auth?.getUser();

      const { data, error } = await supabase?.from('service_schedules')?.insert({
          user_id: user?.id || null,
          name: scheduleData?.name,
          phone: scheduleData?.phone,
          email: scheduleData?.email || null,
          service_type: scheduleData?.serviceType,
          scheduled_date: scheduleData?.scheduledDate,
          scheduled_time: scheduleData?.scheduledTime,
          message: scheduleData?.message || null
        }, { returning: 'minimal' });

      if (error) throw error;
      return { data, error: null };
    } catch (error) {
      return { data: null, error };
    }
  },

  // Get user's own schedules
  async getUserSchedules() {
    try {
      const { data: { user } } = await supabase?.auth?.getUser();
      if (!user) throw new Error('Not authenticated');

      const { data, error } = await supabase?.from('service_schedules')?.select('*')?.eq('user_id', user?.id)?.order('scheduled_date', { ascending: true });

      if (error) throw error;
      return { data, error: null };
    } catch (error) {
      return { data: null, error };
    }
  },

  // Get all schedules (admin only)
  async getAllSchedules() {
    try {
      const { data, error } = await supabase?.from('service_schedules')?.select('*')?.order('scheduled_date', { ascending: true });

      if (error) throw error;
      return { data, error: null };
    } catch (error) {
      return { data: null, error };
    }
  },

  // Update schedule status (admin only)
  async updateStatus(scheduleId, status, adminNotes = null) {
    try {
      const updates = { status };
      if (adminNotes !== null) {
        updates.admin_notes = adminNotes;
      }

      const { data, error } = await supabase?.from('service_schedules')?.update(updates)?.eq('id', scheduleId)?.select()?.single();

      if (error) throw error;
      return { data, error: null };
    } catch (error) {
      return { data: null, error };
    }
  },

  // Delete schedule (admin only)
  async delete(scheduleId) {
    try {
      const { error } = await supabase?.from('service_schedules')?.delete()?.eq('id', scheduleId);

      if (error) throw error;
      return { error: null };
    } catch (error) {
      return { error };
    }
  }
};